import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IFavorite, defaultValue } from 'app/shared/model/favorite.model';
// 请求
export const ACTION_TYPES = {
  FETCH_FAVORITE_LIST: 'favorite/FETCH_FAVORITE_LIST',
  FETCH_FAVORITE: 'favorite/FETCH_FAVORITE',
  CREATE_FAVORITE: 'favorite/CREATE_FAVORITE',
  UPDATE_FAVORITE: 'favorite/UPDATE_FAVORITE',
  DELETE_FAVORITE: 'favorite/DELETE_FAVORITE',
  RESET: 'favorite/RESET'
};
// state
const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IFavorite>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false
};

export type FavoriteState = Readonly<typeof initialState>;

// Reducer

export default (state: FavoriteState = initialState, action): FavoriteState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_FAVORITE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_FAVORITE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_FAVORITE):
    case REQUEST(ACTION_TYPES.UPDATE_FAVORITE):
    case REQUEST(ACTION_TYPES.DELETE_FAVORITE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_FAVORITE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_FAVORITE):
    case FAILURE(ACTION_TYPES.CREATE_FAVORITE):
    case FAILURE(ACTION_TYPES.UPDATE_FAVORITE):
    case FAILURE(ACTION_TYPES.DELETE_FAVORITE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_FAVORITE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_FAVORITE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_FAVORITE):
    case SUCCESS(ACTION_TYPES.UPDATE_FAVORITE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_FAVORITE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/favorites';

// Actions

export const getEntities: ICrudGetAllAction<IFavorite> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_FAVORITE_LIST,
  payload: axios.get<IFavorite>(`${apiUrl}?cacheBuster=${new Date().getTime()}`)
});

export const getEntity: ICrudGetAction<IFavorite> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_FAVORITE,
    payload: axios.get<IFavorite>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IFavorite> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_FAVORITE,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IFavorite> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_FAVORITE,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IFavorite> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_FAVORITE,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
